import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { MessageSquareText } from 'lucide-react';

interface CannedResponse {
  responseId: string;
  title: string;
  content: string;
}

interface CannedResponsePickerProps {
  responses: CannedResponse[];
  onSelect: (content: string) => void;
}

export function CannedResponsePicker({ responses, onSelect }: CannedResponsePickerProps) {
  if (responses.length === 0) {
    return null;
  }

  const handleValueChange = (responseId: string) => {
    const response = responses.find((r) => r.responseId === responseId);
    if (response) {
      onSelect(response.content);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <MessageSquareText className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <Select onValueChange={handleValueChange}>
        <SelectTrigger className="w-[220px]">
          <SelectValue placeholder="Insert canned response..." />
        </SelectTrigger>
        <SelectContent>
          {responses.map((response) => (
            <SelectItem key={response.responseId} value={response.responseId}>
              <div className="flex flex-col">
                <span>{response.title}</span>
                <span className="text-xs text-muted-foreground line-clamp-1">
                  {response.content}
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
